/** buildings: ad-network pack — a building is a player group with details. Arabic is a draft for native review. */
const en = {
  "building": "Building",
  "new": "New building",
  "create": "Create building",
  "kind": "Show",
  "kind_all": "All",
  "kind_buildings": "Buildings",
  "kind_groups": "Groups",
  "isBuilding": "This is a building",
  "hint": "A building (site) groups the screens at one location. Building owners, ad history and live preview work per building.",
  "mark": "Mark as a building",
  "unmark": "Not a building",
  "unmarkQ": "Make “{name}” an ordinary player group? Its address and contact details are removed; its players and content stay.",
  "save": "Save building details",
  "address": "Address",
  "addressPh": "Street, city",
  "pin": "Map pin",
  "pinPh": "Latitude, longitude (e.g. 24.7136, 46.6753)",
  "fromPlayers": "Use the players' location",
  "openMap": "Open in map",
  "contactName": "On-site contact",
  "contactPhone": "Phone",
  "contactEmail": "Email",
  "notes": "Notes",
  "notesPh": "Access hours, where the screens are, parking…",
};
const ar: typeof en = {
  "building": "مبنى",
  "new": "مبنى جديد",
  "create": "إنشاء المبنى",
  "kind": "عرض",
  "kind_all": "الكل",
  "kind_buildings": "المباني",
  "kind_groups": "المجموعات",
  "isBuilding": "هذه المجموعة مبنى",
  "hint": "يجمع المبنى (الموقع) الشاشات في مكان واحد. صلاحيات ملاك المباني وسجل الإعلانات والمعاينة المباشرة تعمل لكل مبنى.",
  "mark": "تحديد كمبنى",
  "unmark": "ليست مبنى",
  "unmarkQ": "تحويل «{name}» إلى مجموعة مشغّلات عادية؟ ستُحذف تفاصيل العنوان وجهة الاتصال، وتبقى المشغّلات والمحتوى.",
  "save": "حفظ تفاصيل المبنى",
  "address": "العنوان",
  "addressPh": "الشارع، المدينة",
  "pin": "الموقع على الخريطة",
  "pinPh": "خط العرض، خط الطول (مثال 24.7136, 46.6753)",
  "fromPlayers": "استخدام موقع المشغّلات",
  "openMap": "فتح في الخريطة",
  "contactName": "جهة الاتصال في الموقع",
  "contactPhone": "الهاتف",
  "contactEmail": "البريد الإلكتروني",
  "notes": "ملاحظات",
  "notesPh": "ساعات الدخول، أماكن الشاشات، المواقف…",
};
export default { en, ar };
